const CustomerThirdPartyStatistics = () =>
  import(
    '@/views/main/wechatMgmt/customerThirdPartyStatistics/CustomerThirdPartyStatistics.vue'
  )

export default {
  path: '/main/wechatMgmt/customerThirdPartyStatistics',
  name: 'customerThirdPartyStatistics',
  component: CustomerThirdPartyStatistics
}
